<template>
  <div v-if="!$apollo.loading" class="main-content">
    <div class="orders-title">Orders</div>
    <text-field
      @input="onInputChange"
      label="Search orders"
      class="searchBar"
      append-icon="search"
    />
    <div v-if="ordersCount" class="table-container">
      <data-table
        :dataItems="filteredOrders"
        :dataCount="ordersCount"
        :columns="columns"
        :currentPageSize="currentPageSize"
        :pageSizes="pageSizes"
        :currentPage="currentPage"
        :maxPage="maxPage"
        :sortField="sortField"
        :ascending="ascending"
        @change-data="setTableData"
        :selectable="true"
        @select="handleSelect"
      />
    </div>
    <div v-else class="orders-no-content">
      <img class="no-content-image" src="/assets/no-tickets.svg" alt="no tickets" />
      <p class="no-content-description">There are no orders made yet.</p>
    </div>
  </div>
</template>

<script>
import { GET_TICKET_SELLERS_ORDERS } from '../../../graphql/order.graphql'
import DataTable from '../../shared/data-table/table.vue'
import moment from 'moment'
import { round } from 'lodash'

export default {
  components: { DataTable },
  data() {
    return {
      orders: [],
      columns: [],
      sortField: 'id',
      ascending: true,
      pageSizes: [5, 10, 25, 50, 100],
      currentPageSize: 10,
      currentPage: 1,
      maxPage: 1,
      ordersCount: 0,
      filteredOrders: null,
    }
  },
  apollo: {
    getTicketSellersOrders: {
      query: GET_TICKET_SELLERS_ORDERS,
      variables() {
        return {
          pageSize: this.currentPageSize,
        }
      },
      result({ data: { getTicketSellersOrders: data }, loading }) {
        if (!loading) {
          const { orders, maxPage, ordersCount } = data
          if (ordersCount) {
            this.orders = orders.map(order => {
              const price = this.calculateOrderTotalPrice(order.price, order.buyer.paymentType)

              return {
                ...order,
                price,
                createdAt: moment(order.createdAt).format('DD.MM.YYYY. HH:mm'),
                event: order.event.title,
                eventDate: moment(order.event.from).format('DD.MM.YYYY. HH:mm'),
              }
            })
            this.filteredOrders = this.orders
            this.ordersCount = ordersCount
            this.maxPage = maxPage
            this.columns = [
              { label: 'Order No.', bind: 'id', cell: 'number-cell' },
              { label: 'Order date', bind: 'createdAt', cell: 'text-cell' },
              { label: 'Event', bind: 'event', cell: 'text-cell' },
              { label: 'Event date', bind: 'eventDate', cell: 'text-cell' },
              { label: 'Total Price', bind: 'price', cell: 'number-cell' },
              { label: 'Status', bind: 'status', cell: 'text-cell' },
            ]
          }
        }
      },
    },
  },
  methods: {
    calculateOrderTotalPrice(price, paymentType) {
      let newPrice = Number(price.split(' ')[1])
      if (paymentType === 'FREE') {
        newPrice = 0
      }

      return `EUR ${newPrice}`
    },
    onInputChange: function (t) {
      const term = t.trim().toLowerCase()
      this.filteredOrders = this.orders.filter(o => {
        return (
          o.id == term ||
          moment(o.createdAt, 'DD-MM-YYYY').format('DD.MM') ==
            moment(term, 'DD.MM').format('DD.MM') ||
          o.event.toLowerCase().includes(term) ||
          Number(o.price.slice(4)).toFixed(2) === Number(term).toFixed(2)
        )
      })
    },
    async setTableData(options) {
      const {
        data: { getTicketSellersOrders: data },
      } = await this.$apollo.query({
        query: GET_TICKET_SELLERS_ORDERS,
        variables: {
          sortField: options.sortField,
          ascending: options.ascending,
          selectedPage: options.currentPage,
          pageSize: options.currentPageSize,
        },
      })

      const { orders, maxPage, ordersCount, selectedPage } = data

      this.orders = orders.map(order => {
        const price = this.calculateOrderTotalPrice(order.price, order.buyer.paymentType)

        return {
          ...order,
          price,
          createdAt: moment(order.createdAt).format('DD.MM.YYYY. HH:mm'),
          event: order.event.title,
          eventDate: moment(order.event.from).format('DD.MM.YYYY. HH:mm'),
        }
      })
      this.filteredOrders = this.orders
      this.maxPage = maxPage
      this.ordersCount = ordersCount
      this.currentPage = selectedPage
    },
    handleSelect(order) {
      this.goTo(this.routes.ticketSeller.orderDetails, { orderId: order.id })
    },
  },
}
</script>
<style scoped>
.main-content {
  position: relative;
}

.orders-title {
  color: #ff4c00;
  font-size: 2.25rem;
  font-weight: 800;
  font-family: 'Raleway', 'sans-serif';
  line-height: 120%;
  letter-spacing: -0.03em;
  margin-bottom: 2rem;
}

.table-container {
  max-width: 1028px;
  width: 100%;
}

.orders-no-content {
  max-width: 676px;
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.no-content-description {
  margin-top: 1rem;
  color: #ff4c00;
  font-size: 1.25rem;
  font-weight: 600;
  font-family: 'Raleway', 'sans-serif';
  line-height: 120%;
  letter-spacing: -0.03em;
  text-align: center;
}
.searchBar {
  background: #f5f5f5;
  border-bottom: 1px solid #d9d9d9;
  border-radius: 4px 4px 0px 0px;
  width: 50%;
  height: 56px;
  margin-bottom: 32px;
}
@media screen and (max-width: 800px) {
  .searchBar {
    width: 100%;
  }
}
</style>
